import type { ReactNode } from 'react';

interface PropsCard {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: PropsCard) {
  return (
    <div
      className={`rounded-panel border border-borde bg-superficie p-4 ${className}`.trim()}
    >
      {children}
    </div>
  );
}

interface PropsSeccion {
  titulo: string;
  descripcion?: string;
  children: ReactNode;
}

export function Seccion({ titulo, descripcion, children }: PropsSeccion) {
  return (
    <section className="space-y-3">
      <div>
        <h2 className="text-base font-semibold text-texto">{titulo}</h2>
        {descripcion !== undefined && (
          <p className="mt-0.5 text-sm text-texto-suave">{descripcion}</p>
        )}
      </div>
      {children}
    </section>
  );
}

interface PropsDato {
  etiqueta: string;
  valor: ReactNode;
  detalle?: string;
}

/** Renglon de etiqueta y valor, para resumenes y configuracion. */
export function Dato({ etiqueta, valor, detalle }: PropsDato) {
  return (
    <div className="flex items-start justify-between gap-4 py-2">
      <div className="min-w-0">
        <dt className="text-sm text-texto-suave">{etiqueta}</dt>
        {detalle !== undefined && <p className="text-xs text-texto-tenue">{detalle}</p>}
      </div>
      <dd className="shrink-0 text-right text-sm font-medium text-texto">{valor}</dd>
    </div>
  );
}

interface PropsVacio {
  titulo: string;
  descripcion?: string;
  children?: ReactNode;
}

/** Estado vacio explicito, en lugar de una seccion en blanco (Req. 17.9). */
export function EstadoVacio({ titulo, descripcion, children }: PropsVacio) {
  return (
    <div className="rounded-panel border border-dashed border-borde-fuerte bg-superficie-suave p-6 text-center">
      <p className="font-medium text-texto">{titulo}</p>
      {descripcion !== undefined && (
        <p className="mt-1 text-sm text-texto-suave">{descripcion}</p>
      )}
      {children !== undefined && <div className="mt-4">{children}</div>}
    </div>
  );
}
